'use strict';

import {Component,Inject, Input} from 'ng-metadata/core';



import { DidUMeanService } from './didUMean.service';
//your imports go here
import {STATE_NAMES} from '../../primoExplore/primoExploreStates.module';
import {ConfigurationUtil} from "../../nddUtils/configurationUtil.service";
import {NewspapersService} from '../../newspapers/newspapers.service';


@Component({
    providers:[DidUMeanService],
selector: 'prm-did-u-mean',
templateUrl: 'components/search/didUMean/did-u-mean.html',
})



export class PrmDidUMean{
    @Input() private didUMean: string;
    private message: string;
    constructor(private didUmeanService: DidUMeanService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('$state') private $state:angular.ui.IStateService,
                @Inject('$stateParams') private $stateParams : ng.ui.IStateParamsService,
                private configurationUtil: ConfigurationUtil,
                private newspapersService : NewspapersService) {
        $translate('results.didumean').then((translation)=>{this.message= translation});
    }

    get stateParams(){
        return this.didUmeanService.getStateParams(this.didUMean, this.$stateParams['query']);
    }
    get STATE(){
        let state = STATE_NAMES.SEARCH;
        if(this.configurationUtil.isSuprima() && this.$state.current.name === STATE_NAMES.JOURNAL_SEARCH ){
            state = STATE_NAMES.JOURNAL_SEARCH;
        }
        else if(this.newspapersService.isNewspapersSearch()){
            state = STATE_NAMES.NEWSPAPERS;
        }
        else if(this.configurationUtil.isSuprima() && this.$state.current.name === STATE_NAMES.DB_SEARCH){
            return STATE_NAMES.DB_SEARCH;
        } if(this.configurationUtil.isSuprima() && this.$state.current.name === STATE_NAMES.ORGANIZATION_LIST){
            return STATE_NAMES.ORGANIZATION_LIST;
        }
        return state;
    }


}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/didUMean/didUMean.directive.ts